define('model-collections/restaurant',['underscore', 'backbone', 'views/restaurant-map'],
  function(_, Backbone, RestaurantMapView) {

    var Restaurant = {};

    Restaurant.Model = Backbone.Model.extend({

      defaults: {
        rendered: false
      }

    });

    Restaurant.Collection = Backbone.Collection.extend({
      model: Restaurant.Model,
      url: '/restaurants/search',

      fetchWithinMap: function(map) {
        map.showLoading();
        var bounds = map.getBounds(),
            params = {
              sw: [bounds.getSouthWest().lat(), bounds.getSouthWest().lng()],
              ne: [bounds.getNorthEast().lat(), bounds.getNorthEast().lng()]
            };
        if (typeof type_id != 'undefined') {
          params.type_id = type_id;
        }
        this.fetchWithin(map, params);
      },

      fetchWithin: function (map, params) {
        this.fetch({
          data: params,
          remove: false,
          success: function(models) {
            models.each(function(model) {
              if (!model.get('rendered')) {
                new RestaurantMapView({model: model, map: map});
                model.set('rendered', true);
              }
            });
            map.hideLoading();
          },
          error: function(models) {
            map.hideLoading();
          }
        });
      }

    });

    return Restaurant;
  }
);
